<top-navig [display]="true" [displayLogo]="false" title="Commandes"></top-navig>
<div class="orders">
    <div class="container head" [class.p-112]="ourApp">
        <div class="row block">
            <div class="col-md-12">
                <h3 class="heading">Mes commandes:</h3>
                <hr class="half_space">
                <div class="expl-div">
                    <table width="100%">
                        <tr>
                            <td>
                                <div class="expl" style="background: #ff0e0e"></div>A traiter
                            </td>
                            <td>
                                <div class="expl" style="background: #ff0"></div>En cuisine
                            </td>
                            <td>
                                <div class="expl" style="background: #D1DADE"></div>Annulée
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="expl" style="background: #00aade"></div>Récuperée
                            </td>
                            <td>
                                <div class="expl" style="background: #0e76bd"></div>Livrée
                            </td>
                            <td>
                                <div class="expl" style="background: green"></div> Validée
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="expl" style="background: #f8ac59"></div>En cours de livraison
                            </td>
                        </tr>
                    </table>
                </div>
                <div *ngIf="orders?.length==0" class="text-center">
                    <p>Aucune commande pour le moment</p>
                </div>
                <div *ngFor="let order of orders;let i=index" class="item" [ngClass]="{'item-v':order.status=='Validée','item-c':order.status=='En cuisine'
                ,'item-a':order.status=='Annulée','item-r':order.status=='Récuperée'
                ,'item-el':order.status=='En cours de livraison','item-l':order.status=='Livrée'}">
                <div class="click"  (click)="seeTicket(i)"></div>
                    <span class="pull-right">{{order.id}}</span>
                    <span>{{order.createdAt | date: 'dd/MM/yyyy HH:mm'}} {{getReadyin(order.createdAt,order.minDelay)}}
                        Min</span>
                    <span  class="type" [ngClass]="{'type-v':order.status=='Validée','type-c':order.status=='En cuisine'
                    ,'type-a':order.status=='Annulée','type-r':order.status=='Récuperée'
                    ,'type-el':order.status=='En cours de livraison','type-l':order.status=='Livrée'}"> &nbsp;&nbsp;&nbsp; {{order.status}}</span>
                    <br>
                    <span>{{order.type}}</span>
                    <br>
                    <span id="mode" *ngFor="let mode of order.PaymentModes">{{mode.paymentMode.label}}</span>
                    <span *ngIf="order?.discount==0" class="pull-right">{{order?.amount | number : '1.2-2'}} €</span>
                    <span *ngIf="order?.discount>0" class="pull-right class-re">
                        <s class="text-danger">{{order?.amount | number : '1.2-2'}} €</s>
                        <br> {{order?.total | number : '1.2-2'}} €
                    </span><br>
                    <div class="payment">
                        <order-pay [loading]="order.loading" class="order-p" (OnPayEvent)="payer(i)" *ngIf="order.idStatus==9 && !order.paid"
                            [createdAt]="order.createdAt"></order-pay>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
<div>
    <a class="add" [routerLink]="'/carte'">
        <img src="assets/images/icons/add.png" alt="">
    </a>
</div>
<ng-template #template>
    <div class="modal-header">
        <button class="btn-close" (click)="bsModalRef.hide()">
            <span></span>
            <span></span>
        </button>
    </div>
    <div class="modal-body">
        <app-ticket id="ticket2" [idOrder]="idOrder2"></app-ticket>
    </div>
</ng-template>